import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header'
import './index.css'
import Footer from '../components/Footer'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: data.site.siteMetadata.description },
        { name: 'keywords', content: data.site.siteMetadata.keywords },
      ]}
      link={[
              {"rel": "icon", 
               "type": "image/svg", 
               "href": "https://p75.tr0.n0.cdn.getcloudapp.com/items/9ZuRJwAQ/07afec68-f67e-48dc-89c2-d6ee6d719598.svg?v=c3ba2c1096648b507106d50d2aa52226"
              }
             ]}
    />
    <Header />
    {children()}
    <Footer />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        description
        keywords
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js